// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellTestCard-cls1_79e","cls2":"UpsellTestCard-cls2_9lM UpsellTestCard-cls1_79e"};